type LandingPageViewScreenArgs = {
  screen?: string
  referrer?: string
  path?: string
  event?: string
}

type LandingPageViewScreenExtra = {
  screen?: string
  path?: string
  referrer?: string
}

export const ViewLandingPageEvent = (args: LandingPageViewScreenArgs) => {
  const { screen, path, referrer } = args

  const extra: LandingPageViewScreenExtra = {
    screen,
    path,
    referrer,
  }

  return {
    event: 'user.view_screen',
    extra,
  }
}
